// src/services/apaleo/index.ts
// Assembles the Apaleo client from its domain modules. Phase 5 of
// plans/monolith-migration-plan.md.
//
// The spread order is irrelevant: every member name is unique across the
// parts (enforced by the split script), so later parts cannot overwrite
// earlier ones. `this` inside each part resolves against the merged object
// at call time, exactly as it did in the original single literal.

import client from './client';
import properties from './properties';
import reservations from './reservations';
import companies from './companies';
import units from './units';
import offers from './offers';
import maintenance from './maintenance';
import autoAssign from './auto-assign';
import folios from './folios';
import invoices from './invoices';
import groups from './groups';
import accounts from './accounts';
import cityTax from './city-tax';
import cityTaxMarkers from './city-tax-markers';
import cityTaxRecalculate from './city-tax-recalculate';
import cityTaxHrs from './city-tax-hrs';

const ApaleoAuth = {
  ...client,
  ...properties,
  ...reservations,
  ...companies,
  ...units,
  ...offers,
  ...maintenance,
  ...autoAssign,
  ...folios,
  ...invoices,
  ...groups,
  ...accounts,
  ...cityTax,
  ...cityTaxMarkers,
  ...cityTaxRecalculate,
  ...cityTaxHrs,
};

export default ApaleoAuth;
